import {
  ContentModuleMeta,
  ContentStat
} from "seneca-common/features/stats/state";
import { chooseMFromN } from "seneca-common/utils/functions";
import shuffle from "seneca-common/utils/functions/random/shuffle";

import { generateMultipleChoiceContent } from "../../multiplechoice/logic/content";
import { GenerateContentOptions } from "../../types";
import { PRETEST_TYPES } from "../data/constants";
import { Content, ContentSource } from "../types";

export const makeGenerateContent = (shuffleValues: boolean = false) => {
  return (
    source: ContentSource,
    { testingActive, maxDifficulty }: GenerateContentOptions,
    contentStat?: ContentStat,
    contentModuleMeta?: ContentModuleMeta
  ): Content => {
    const { statement, values: sourceValues } = source;

    const values = shuffleValues ? shuffle(sourceValues) : sourceValues;

    let multipleChoiceContent = {
      pretest: source.pretest
    };

    if (!testingActive) {
      return {
        ...multipleChoiceContent,
        list: {
          statement,
          values: values.map((value: any) => {
            return { ...value, testing: false };
          })
        }
      } as unknown as Content;
    }

    const numberOfListItems = source.values.length;
    const numberToTest = calculateNumberToStudy(
      contentStat!,
      numberOfListItems,
      maxDifficulty
    );
    const testedIndexes = chooseMFromN(numberToTest, numberOfListItems);

    let listAnswers = values.map((value: any, index: number) => {
      if (testedIndexes.includes(index)) {
        return { ...value, testing: true };
      } else {
        return { ...value, testing: false };
      }
    });

    if (
      source.pretest === PRETEST_TYPES.ALWAYS ||
      source.pretest === PRETEST_TYPES.SOMETIMES
    ) {
      const { pretestQuestion, prestestCorrectAnswer, prestestWrongAnswers } =
        source as any;
      multipleChoiceContent = {
        pretest: source.pretest,
        // @ts-ignore
        multipleChoice: generateMultipleChoiceContent({
          question: pretestQuestion,
          wrongAnswers: prestestWrongAnswers,
          correctAnswer: prestestCorrectAnswer
        })
      };
    }

    return {
      ...multipleChoiceContent,
      list: {
        statement,
        values: listAnswers
      }
    } as unknown as Content;
  };
};

//extracted logic
export function calculateNumberToStudy(
  meta: ContentStat,
  numberOfListItems: number,
  maxDifficulty: boolean | null | undefined
): number {
  if (maxDifficulty) return numberOfListItems;

  let numberToTest;

  const timesStudied = meta ? meta.timesStudied : 0;

  if (timesStudied < 2) {
    numberToTest = 1;
  } else if (timesStudied < 3) {
    numberToTest = Number(Math.ceil(0.5 * numberOfListItems));
  } else if (timesStudied < 5) {
    numberToTest = Number(Math.ceil(0.66 * numberOfListItems));
  } else {
    numberToTest = numberOfListItems;
  }

  if (meta) {
    const { lastScore, averageScore } = meta;

    if (averageScore && lastScore) {
      if (averageScore - lastScore > 0.2) {
        //someone is bad at it
        numberToTest--;
      }

      if (lastScore - averageScore > 0.2) {
        //someone is good at it
        numberToTest++;
      }
    }
  }

  //just to make sure it's within the bounds
  numberToTest = Math.max(numberToTest, 1);
  numberToTest = Math.min(numberToTest, numberOfListItems);

  return numberToTest;
}

export const generateContent = makeGenerateContent();
